import { bacnetAdapter, ProtocolAdapter } from './bacnet';
import { modbusAdapter } from './modbus';

export type ProtocolType = 'bacnet' | 'modbus';

export const protocolAdapters: Record<ProtocolType, ProtocolAdapter> = {
  bacnet: bacnetAdapter,
  modbus: modbusAdapter,
};

export const getProtocolAdapter = (protocol: ProtocolType = 'bacnet'): ProtocolAdapter => {
  const adapter = protocolAdapters[protocol];
  if (!adapter) {
    throw new Error(`Protocol adapter for "${protocol}" is not implemented.`);
  }
  return adapter;
};

export * from './bacnet';
export * from './modbus';
